import { render, staticRenderFns } from "./MapSubscription.vue?vue&type=template&id=06fb2f28"
import script from "./MapSubscription.vue?vue&type=script&lang=js"
export * from "./MapSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports